import makeStyles from 'e100-react-components/lib/styles/makeStyles';

const useStyles = makeStyles(({ spacing, typography, palette, shape, transitions }) => ({
  formControlRoot: ({ variant }: any) => ({
    paddingRight: spacing(),
    paddingLeft: spacing(),
    borderBottom: `1px solid ${palette.grey[200]}`,
    '&:hover .rootButtonClear': {
      opacity: 1
    },
    '& > div:after': {
      display: 'none'
    },
    '& > div:before': {
      display: 'none'
    },
    ...variant === 'filled' && {
      paddingLeft: 0,
      paddingRight: 0,
      borderBottom: 'none'
    },
    ...variant === 'outlined' && {
      border: `1px solid ${palette.grey[400]}`,
      borderBottomColor: palette.grey[400],
      paddingLeft: 0,
      paddingRight: 0,
      borderRadius: shape.borderRadius,

      '& > label': {
        transform: 'translate(8px, -5.5px) scale(0.75)',
        background: palette.common.white,
        paddingLeft: spacing(0.5),
        paddingRight: spacing(0.5),
      },

      '& > div': {
        marginTop: 0
      },

      '&:hover': {
        borderColor: palette.primary.main
      }
    }
  }),
  selectRoot: ({ variant }: any) => ({
    paddingTop: spacing(2.25),
    paddingBottom: spacing(2.25),
    paddingLeft: spacing(6),
    paddingRight: `${spacing(8)}px !important`,
    fontSize: typography.body2.fontSize,

    ...variant === 'filled' && {
      backgroundColor: palette.grey['100'],
      padding: `${spacing(1.3)}px ${spacing(2)}px !important`,
      borderRadius: shape.borderRadius,
      border: `1px solid ${palette.grey[100]}`,
      transition: transitions.create(['background-color', 'border-color'], {
        duration: transitions.duration.shortest,
      }),
      '&:hover': {
        backgroundColor: 'transparent',
        borderColor: palette.primary.main
      }
    },

    ...variant === 'outlined' && {
      padding: `${spacing(1.3)}px ${spacing(2)}px ${spacing(1.3)}px ${spacing(1.5)}px !important`,
      paddingRight: `${spacing(7.5)}px !important`
    }
  }),
  selectMenu: {
    // @ts-ignore
    marginLeft: ({ isMobile }) => `${isMobile ? -8 : 0}px`
  },
  menuItemRoot: {
    paddingLeft: spacing(1.5),
    paddingRight: spacing(1.5)
  },
  menuItemText: {
    fontSize: typography.body1.fontSize
  },
  menuHeaderSearch: {
    paddingRight: spacing(),
    '& input': {
      fontSize: typography.body2.fontSize,
      paddingTop: spacing(2),
      paddingBottom: spacing(2),
      paddingLeft: spacing(2)
    },
    '& > div:after': {
      display: 'none'
    },
    '& > div:before': {
      display: 'none'
    }
  },
  searchIcon: {
    fontSize: typography.h5.fontSize,
    color: palette.secondary.main
  },
  selectIcon: {
    right: spacing()
  },
  checkboxContainer: {
    paddingLeft: '0 !important'
  }
}));

export default useStyles;
